export class AutomationList {
  automationName: string;
  aUID: string;
  status: string;

  companyName:string;
  userId:number;
  userUID:string;
  totalCount:number;
}

export class AutomationListRequestDTO {
  companyName:string;
  userId:number;
  offset = 0;
  pageSize = 10
}

export class AutomationCompleteMailDTO
{
   clientName:string;
   automationName :string;
   companyName:string
}